import axiosInstance from "../axiosClient";
import { addExpertise, EditDetails, expertiseList } from "../config";

export const getExpertise = async (name, limit, start_key) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${expertiseList}${queryString}`);
};

export const createExpertise = async (data) => {
  return await axiosInstance.post(addExpertise, data);
};

export const updateExpertiseDetails = async (data) => {
  return await axiosInstance.put(EditDetails, data);
};
